import { Button, CircularProgress, Stack } from '@mui/material';
import React, { useMemo } from 'react';
import DashboardBox from '../components/DashboardBox';
import { Form, Formik } from 'formik';
import TextField from '../components/formik/TextField';

const Admin = () => {
  const initialValues = useMemo(
    () => ({
      impersonatedUserId: localStorage.getItem('impersonatedUserId') || '',
    }),
    [],
  );

  const onSubmit = (values, { setSubmitting }) => {
    localStorage.setItem('impersonatedUserId', values.impersonatedUserId);
    setSubmitting(false);
  };

  return (
    <div style={{ display: 'inline-flex', width: '100%', maxWidth: 400 }}>
      <DashboardBox>
        <Stack spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <p className="title">Admin</p>
          </Stack>
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({ isValid, isSubmitting }) => (
              <Form>
                <Stack spacing={2}>
                  <TextField name="impersonatedUserId" label="User id*" />

                  <Button variant="contained" type="submit" disabled={!isValid || isSubmitting}>
                    Opslaan
                    {isSubmitting && <CircularProgress size={14} sx={{ ml: 1 }} />}
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </DashboardBox>
    </div>
  );
};

export default Admin;
